module.exports = __webpack_public_path__ + "static/media/marcas (1).a651e4f3.png";